export default "__VITE_ASSET__BlsX$gME__"